import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-REC-range',
  templateUrl: './REC-Range.component.html',
  styleUrls: ['./REC-Range.component.css']
})
export class RECRangeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
